// import React, { useEffect, useState, useCallback } from "react";
// import {
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Button,
//   Grid,
//   Chip,
//   Paper,
//   useTheme,
//   useMediaQuery,
//   Alert,
//   Fade
// } from "@mui/material";
// import {
//   TrendingUp,
//   AccountBalanceWallet,
//   Download,
//   ArrowForwardIos,
//   BarChart,
//   Calculate,
//   ReceiptLong
// } from "@mui/icons-material";
// import api from "../../../../api/axiosInterceptor";
// import { SnackBarComponent } from "../../../../Components/snackBar/snackBar";

// export default function FEClaimsDashboard() {
//   const [feNames, setFeNames] = useState([]);
//   const [selectedFE, setSelectedFE] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState("all");
//   const [summary, setSummary] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [loadingSummary, setLoadingSummary] = useState(false);
//   const [downloading, setDownloading] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: "",
//     severity: "info"
//   });

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const showSnackbar = (msg, sev = "info") =>
//     setSnackbar({ open: true, message: msg, severity: sev });
//   const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

//   // Fetch FE list
//   const fetchFENames = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await api.get("/claim-mgmt/ca-fe-list/");
      
//       if (res.data.message) {
//         showSnackbar(res.data.message, "success");
//       }
      
//       setFeNames(res.data.fe_names || []);
//       if (res.data.fe_names?.length > 0) {
//         setSelectedFE(res.data.fe_names[0]);
//       }
//     } catch (err) {
//       const errorMsg = err.response?.data?.message || 
//                       err.response?.data?.error || 
//                       err.response?.data?.detail ||
//                       "Failed to load Financial Establishments";
//       showSnackbar(errorMsg, "error");
//       console.error("Error fetching FE names:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   // Fetch summary
//   const fetchSummary = useCallback(async () => {
//     if (!selectedFE) {
//       showSnackbar("Please select a Financial Establishment first", "warning");
//       return;
//     }
//     setLoadingSummary(true);
//     try {
//       const params = { fe_name: selectedFE };
//       const res = await api.get("/claim-mgmt/fe-claims-summary/", { params });
      
//       if (res.data.message) {
//         showSnackbar(res.data.message, "success");
//       }
      
//       setSummary(res.data);
//     } catch (err) {
//       const errorMsg = err.response?.data?.message || 
//                       err.response?.data?.error || 
//                       err.response?.data?.detail ||
//                       "Failed to load summary data";
//       showSnackbar(errorMsg, "error");
//       console.error("Error fetching summary:", err);
//     } finally {
//       setLoadingSummary(false);
//     }
//   }, [selectedFE]);

//   // Download detailed report
//   const downloadReport = useCallback(async () => {
//     if (!selectedFE) {
//       showSnackbar("Please select a Financial Establishment first", "warning");
//       return;
//     }
//     setDownloading(true);
//     try {
//       const params = {
//         fe_name: selectedFE,
//         status: selectedStatus
//       };
//       const res = await api.get("/claim-mgmt/claim-report/", { 
//         params, 
//         responseType: 'blob' 
//       });
      
//       const contentDisposition = res.headers['content-disposition'];
//       const filename = contentDisposition?.match(/filename="(.+)"/)?.[1] || 
//                       `claims_report_${selectedFE.replace(/ /g, '_')}_${selectedStatus}.xlsx`;
      
//       showSnackbar(`"${filename}" downloaded successfully!`, "success");
      
//       const url = window.URL.createObjectURL(new Blob([res.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', filename);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
      
//     } catch (err) {
//       const errorMsg = err.response?.data?.message || 
//                       err.response?.data?.error || 
//                       err.response?.data?.detail ||
//                       "Failed to download report";
//       showSnackbar(errorMsg, "error");
//       console.error("Download error:", err);
//     } finally {
//       setDownloading(false);
//     }
//   }, [selectedFE, selectedStatus]);

//   useEffect(() => {
//     fetchFENames();
//   }, [fetchFENames]);

//   useEffect(() => {
//     if (selectedFE) {
//       fetchSummary();
//     }
//   }, [fetchSummary]);

//   const statusOptions = [
//     { value: "all", label: "All Status" },
//     { value: "Normal", label: "Normal" },
//     { value: "Delayed", label: "Delayed" },
//     { value: "Rejected", label: "Rejected" },
//     { value: "Settled", label: "Settled" }
//   ];

//   const cards = summary ? [
//     {
//       title: "Total Claimants",
//       value: summary.total_claimants?.toLocaleString() || 0,
//       icon: <BarChart sx={{ fontSize: 50, color: "white" }} />,
//       bgColor: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       chip: selectedFE ? <Chip label={selectedFE} size="small" color="primary" /> : null
//     },
//     {
//       title: "Total Claim Amount",
//       value: `₹${(summary.total_claim_amount || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`,
//       icon: <TrendingUp sx={{ fontSize: 50, color: "white" }} />,
//       bgColor: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
//     },
//     {
//       title: "Total Deposited",
//       value: `₹${(summary.total_deposited || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`,
//       icon: <AccountBalanceWallet sx={{ fontSize: 50, color: "white" }} />,
//       bgColor: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
//     },
//     {
//       title: "Total Returned/Received",
//       value: `₹${(summary.total_returned_received || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`,
//       icon: <Calculate sx={{ fontSize: 50, color: "white" }} />,
//       bgColor: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
//     },
//     {
//       title: "Total Loan",
//       value: `₹${(summary.total_loan || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`,
//       icon: <ReceiptLong sx={{ fontSize: 50, color: "white" }} />,
//       bgColor: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
//     }
//   ] : [];

//   return (
//     <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1400, mx: "auto" }}>
//       {/* Header */}
//       <Box sx={{ mb: 4 }}>
//         <Typography
//           variant="h3"
//           sx={{
//             fontWeight: 800,
//             textAlign: "center",
//             background: "linear-gradient(90deg, #2563EB, #34D399, #F59E0B)",
//             WebkitBackgroundClip: "text",
//             WebkitTextFillColor: "transparent",
//             mb: 1,
//             textShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)"
//           }}
//         >
//           Financial Establishment Dashboard
//         </Typography>
//         <Typography
//           variant="h6"
//           sx={{
//             textAlign: "center",
//             color: "text.secondary",
//             fontWeight: 400
//           }}
//         >
//           Select FE and Status to view consolidated claims summary
//         </Typography>
//       </Box>

//       {/* Filters */}
//       <Paper 
//         elevation={3} 
//         sx={{ p: 3, mb: 4, borderRadius: 3 }}
//       >
//         <Grid container spacing={3} alignItems="center">
//           <Grid item xs={12} md={4}>
//             <FormControl fullWidth size="small" disabled={loading}>
//               <InputLabel>Financial Establishment</InputLabel>
//               <Select
//                 value={selectedFE}
//                 label="Financial Establishment"
//                 onChange={(e) => setSelectedFE(e.target.value)}
//                 disabled={loading}
//               >
//                 {feNames.map((fe) => (
//                   <MenuItem key={fe} value={fe}>{fe}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} md={3}>
//             <FormControl fullWidth size="small">
//               <InputLabel>Status</InputLabel>
//               <Select
//                 value={selectedStatus}
//                 label="Status"
//                 onChange={(e) => setSelectedStatus(e.target.value)}
//               >
//                 {statusOptions.map((option) => (
//                   <MenuItem key={option.value} value={option.value}>
//                     {option.label}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Grid>
          
//           <Grid item xs={12} md={5} container justifyContent="center">
//             <Button
//               variant="contained"
//               size="large"
//               onClick={fetchSummary}
//               disabled={!selectedFE || loadingSummary || loading}
//               startIcon={loadingSummary ? <CircularProgress size={20} /> : <ArrowForwardIos />}
//               sx={{ minWidth: 200, height: 48 }}
//             >
//               {loadingSummary ? "Loading..." : "Update Summary"}
//             </Button>
//           </Grid>
//         </Grid>
//       </Paper>

//       {/* Summary Cards */}
//       <Fade in={!!summary} timeout={600}>
//         <Box>
//           {loading ? (
//             <Box
//               display="flex"
//               justifyContent="center"
//               alignItems="center"
//               sx={{ height: "50vh" }}
//             >
//               <CircularProgress size={60} />
//             </Box>
//           ) : summary ? (
//             <>
//               <Grid container spacing={3} sx={{ mb: 4 }}>
//                 {cards.map((card, idx) => (
//                   <Grid item xs={12} sm={6} md={3} lg={2.4} key={idx}>
//                     <Card
//                       sx={{
//                         height: "100%",
//                         background: card.bgColor,
//                         color: "white",
//                         borderRadius: 3,
//                         textAlign: "center",
//                         boxShadow: 8,
//                         transition: "all 0.3s ease",
//                         position: "relative",
//                         overflow: "hidden",
//                         "&:hover": { 
//                           transform: "translateY(-8px) scale(1.02)",
//                           boxShadow: 12 
//                         }
//                       }}
//                     >
//                       <CardContent sx={{ p: 3, pt: 4 }}>
//                         {card.chip && (
//                           <Chip 
//                             label={card.chip.props.label} 
//                             size="small" 
//                             sx={{ position: "absolute", top: 12, left: 12 }} 
//                           />
//                         )}
//                         <Box display="flex" justifyContent="center" mb={2}>
//                           {card.icon}
//                         </Box>
//                         <Typography variant="h6" sx={{ mb: 1, opacity: 0.9 }}>
//                           {card.title}
//                         </Typography>
//                         <Typography variant="h4" sx={{ fontWeight: 800, mb: 0.5 }}>
//                           {card.value}
//                         </Typography>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 ))}
//               </Grid>

//               {/* Download Button */}
//               <Paper 
//                 elevation={4} 
//                 sx={{ p: 4, borderRadius: 3, textAlign: "center" }}
//               >
//                 <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
//                   Download Detailed Report
//                 </Typography>
//                 <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
//                   Export all claims data for {selectedFE} ({selectedStatus.toUpperCase()})
//                 </Typography>
//                 <Box sx={{ mt: 2 }}>
//                   <Button
//                     variant="contained"
//                     size="large"
//                     onClick={downloadReport}
//                     disabled={downloading || !summary}
//                     startIcon={
//                       downloading ? (
//                         <CircularProgress size={20} color="inherit" />
//                       ) : (
//                         <Download />
//                       )
//                     }
//                     sx={{ 
//                       px: 6, 
//                       py: 1.5, 
//                       fontSize: "1.1rem",
//                       background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
//                       boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
//                       "&:hover": {
//                         background: "linear-gradient(45deg, #FF8E53 30%, #FE6B8B 90%)",
//                         boxShadow: "0 5px 15px 2px rgba(255, 105, 135, .4)"
//                       }
//                     }}
//                   >
//                     {downloading ? "Downloading..." : `Download ${selectedFE || "Report"}`}
//                   </Button>
//                 </Box>
//               </Paper>
//             </>
//           ) : (
//             <Alert severity="info" sx={{ mt: 4 }}>
//               Select a Financial Establishment to view summary
//             </Alert>
//           )}
//         </Box>
//       </Fade>

//       <SnackBarComponent
//         open={snackbar.open}
//         message={snackbar.message}
//         severity={snackbar.severity}
//         onClose={closeSnackbar}
//       />
//     </Box>
//   );
// }


import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Grid,
  Chip,
  Paper,
  useTheme,
  useMediaQuery,
  Alert,
  Fade
} from "@mui/material";
import {
  TrendingUp,
  AccountBalanceWallet,
  Download,
  ArrowForwardIos,
  BarChart,
  Calculate,
  ReceiptLong,
  Assessment,
  CheckCircle
} from "@mui/icons-material";
import api from "../../../../api/axiosInterceptor";
import { SnackBarComponent } from "../../../../Components/snackBar/snackBar";

export default function FEClaimsDashboard() {
  const [feNames, setFeNames] = useState([]);
  const [selectedFE, setSelectedFE] = useState("");
  const [summaryStatus, setSummaryStatus] = useState("all");
  const [downloadStatus, setDownloadStatus] = useState("all");
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const showSnackbar = (msg, sev = "info") =>
    setSnackbar({ open: true, message: msg, severity: sev });
  const closeSnackbar = () => setSnackbar({ ...snackbar, open: false });

  // Fetch FE list
  const fetchFENames = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/claim-mgmt/ca-fe-list/");
      
      if (res.data.message) {
        showSnackbar(res.data.message, "success");
      }
      
      setFeNames(res.data.fe_names || []);
      if (res.data.fe_names?.length > 0) {
        setSelectedFE(res.data.fe_names[0]);
      }
    } catch (err) {
      const errorMsg = err.response?.data?.message || 
                      err.response?.data?.error || 
                      err.response?.data?.detail ||
                      "Failed to load Financial Establishments";
      showSnackbar(errorMsg, "error");
      console.error("Error fetching FE names:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // Fetch summary
  const fetchSummary = useCallback(async () => {
    if (!selectedFE) {
      showSnackbar("Please select a Financial Establishment first", "warning");
      return;
    }
    setLoadingSummary(true);
    try {
      const params = { 
        fe_name: selectedFE,
        status: summaryStatus
      };
      const res = await api.get("/claim-mgmt/fe-claims-summary/", { params });
      
      if (res.data.message) {
        showSnackbar(res.data.message, "success");
      }
      
      setSummary(res.data);
    } catch (err) {
      const errorMsg = err.response?.data?.message || 
                      err.response?.data?.error || 
                      err.response?.data?.detail ||
                      "Failed to load summary data";
      showSnackbar(errorMsg, "error");
      console.error("Error fetching summary:", err);
    } finally {
      setLoadingSummary(false);
    }
  }, [selectedFE, summaryStatus]);

  // Download detailed report
  const downloadReport = useCallback(async () => {
    if (!selectedFE) {
      showSnackbar("Please select a Financial Establishment first", "warning");
      return;
    }
    setDownloading(true);
    try {
      const params = {
        fe_name: selectedFE,
        status: downloadStatus
      };
      const res = await api.get("/claim-mgmt/claim-report/", { 
        params, 
        responseType: 'blob' 
      });
      
      const contentDisposition = res.headers['content-disposition'];
      const filename = contentDisposition?.match(/filename="(.+)"/)?.[1] || 
                      `claims_report_${selectedFE.replace(/ /g, '_')}_${downloadStatus}.xlsx`;
      
      showSnackbar(`"${filename}" downloaded successfully!`, "success");
      
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
    } catch (err) {
      const errorMsg = err.response?.data?.message || 
                      err.response?.data?.error || 
                      err.response?.data?.detail ||
                      "Failed to download report";
      showSnackbar(errorMsg, "error");
      console.error("Download error:", err);
    } finally {
      setDownloading(false);
    }
  }, [selectedFE, downloadStatus]);

  useEffect(() => {
    fetchFENames();
  }, [fetchFENames]);

  useEffect(() => {
    if (selectedFE) {
      fetchSummary();
    }
  }, [fetchSummary]);

  const statusOptions = [
    { value: "all", label: "All Status" },
    { value: "Normal", label: "Normal" },
    { value: "Delayed", label: "Delayed" },
    { value: "Rejected", label: "Rejected" },
    { value: "Settled", label: "Settled" }
  ];

  const cards = summary ? [
    {
      title: "Total Claimants",
      value: summary.total_claimants?.toLocaleString() || 0,
      icon: <BarChart sx={{ fontSize: 50, color: "white" }} />,
      bgColor: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      chip: selectedFE ? <Chip label={selectedFE} size="small" color="primary" /> : null
    },
    {
      title: "Total Claim Amount",
      value: `₹${(summary.total_claim_amount || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`,
      icon: <TrendingUp sx={{ fontSize: 50, color: "white" }} />,
      bgColor: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    },
    {
      title: "Total Deposited",
      value: `₹${(summary.total_deposited || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`,
      icon: <AccountBalanceWallet sx={{ fontSize: 50, color: "white" }} />,
      bgColor: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
    },
    {
      title: "Total Returned/Received",
      value: `₹${(summary.total_returned_received || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`,
      icon: <Calculate sx={{ fontSize: 50, color: "white" }} />,
      bgColor: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"
    },
    {
      title: "Total Loan",
      value: `₹${(summary.total_loan || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`,
      icon: <ReceiptLong sx={{ fontSize: 50, color: "white" }} />,
      bgColor: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"
    },
    {
      title: "Total Amount Payable as per CA Assessment",
      value: `₹${(summary.total_claims_as_per_ca || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`,
      icon: <Assessment sx={{ fontSize: 50, color: "white" }} />,
      bgColor: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)"  // SAME VIBRANT COLORS
    },
    {
      title: "Settled Amount",
      value: `₹${(summary.settled_amt || 0).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`,
      icon: <CheckCircle sx={{ fontSize: 50, color: "white" }} />,
      bgColor: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)"  // SAME VIBRANT COLORS
    }
  ] : [];

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 1400, mx: "auto" }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            textAlign: "center",
            background: "linear-gradient(90deg, #2563EB, #34D399, #F59E0B)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            mb: 1,
            textShadow: "1px 1px 2px rgba(0, 0, 0, 0.1)"
          }}
        >
          Financial Establishment Dashboard
        </Typography>
        <Typography
          variant="h6"
          sx={{
            textAlign: "center",
            color: "text.secondary",
            fontWeight: 400
          }}
        >
          Select FE and Status to view consolidated claims summary
        </Typography>
      </Box>

      {/* Filters */}
      <Paper 
        elevation={3} 
        sx={{ p: 3, mb: 4, borderRadius: 3 }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small" disabled={loading}>
              <InputLabel>Financial Establishment</InputLabel>
              <Select
                value={selectedFE}
                label="Financial Establishment"
                onChange={(e) => setSelectedFE(e.target.value)}
                disabled={loading}
              >
                {feNames.map((fe) => (
                  <MenuItem key={fe} value={fe}>{fe}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Summary Status</InputLabel>
              <Select
                value={summaryStatus}
                label="Summary Status"
                onChange={(e) => setSummaryStatus(e.target.value)}
              >
                {statusOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={3}>
            <FormControl fullWidth size="small">
              <InputLabel>Download Status</InputLabel>
              <Select
                value={downloadStatus}
                label="Download Status"
                onChange={(e) => setDownloadStatus(e.target.value)}
              >
                {statusOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          
          <Grid item xs={12} md={3} container justifyContent="center">
            <Button
              variant="contained"
              size="large"
              onClick={fetchSummary}
              disabled={!selectedFE || loadingSummary || loading}
              startIcon={loadingSummary ? <CircularProgress size={20} /> : <ArrowForwardIos />}
              sx={{ minWidth: 200, height: 48 }}
            >
              {loadingSummary ? "Loading..." : "Update Summary"}
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Summary Cards - 4+3 Layout */}
      <Fade in={!!summary} timeout={600}>
        <Box>
          {loading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ height: "50vh" }}
            >
              <CircularProgress size={60} />
            </Box>
          ) : summary ? (
            <>
              {/* ROW 1: 4 Cards */}
              <Grid container spacing={3} sx={{ mb: 4 }}>
                {cards.slice(0, 4).map((card, idx) => (
                  <Grid item xs={12} sm={6} md={6} lg={3} key={`row1-${idx}`}>
                    <Card
                      sx={{
                        height: 180,
                        background: card.bgColor,
                        color: "white",
                        borderRadius: 3,
                        textAlign: "center",
                        boxShadow: 8,
                        transition: "all 0.3s ease",
                        position: "relative",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        "&:hover": { 
                          transform: "translateY(-8px) scale(1.02)",
                          boxShadow: 12 
                        }
                      }}
                    >
                      <CardContent sx={{ p: 3, pt: 4, flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                        {card.chip && (
                          <Chip 
                            label={card.chip.props.label} 
                            size="small" 
                            sx={{ position: "absolute", top: 12, left: 12 }} 
                          />
                        )}
                        <Box display="flex" justifyContent="center" mb={1}>
                          {card.icon}
                        </Box>
                        <Typography variant="h6" sx={{ mb: 1, opacity: 0.9, fontSize: '0.9rem' }}>
                          {card.title}
                        </Typography>
                        <Typography variant="h4" sx={{ fontWeight: 800, fontSize: '1.8rem' }}>
                          {card.value}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              {/* ROW 2: 3 Cards */}
              <Grid container spacing={3} sx={{ mb: 4 }}>
                {cards.slice(4, 7).map((card, idx) => (
                  <Grid item xs={12} sm={6} md={4} lg={4} key={`row2-${idx}`}>
                    <Card
                      sx={{
                        height: 180,
                        background: card.bgColor,
                        color: "white",
                        borderRadius: 3,
                        textAlign: "center",
                        boxShadow: 8,
                        transition: "all 0.3s ease",
                        position: "relative",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        "&:hover": { 
                          transform: "translateY(-8px) scale(1.02)",
                          boxShadow: 12 
                        }
                      }}
                    >
                      <CardContent sx={{ p: 3, pt: 4, flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                        {card.chip && (
                          <Chip 
                            label={card.chip.props.label} 
                            size="small" 
                            sx={{ position: "absolute", top: 12, left: 12 }} 
                          />
                        )}
                        <Box display="flex" justifyContent="center" mb={1}>
                          {card.icon}
                        </Box>
                        <Typography variant="h6" sx={{ mb: 1, opacity: 0.9, fontSize: '0.9rem' }}>
                          {card.title}
                        </Typography>
                        <Typography variant="h4" sx={{ fontWeight: 800, fontSize: '1.8rem' }}>
                          {card.value}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>

              {/* Download Button */}
              <Paper 
                elevation={4} 
                sx={{ p: 4, borderRadius: 3, textAlign: "center" }}
              >
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  Download Detailed Report
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
                  Export claims data for {selectedFE} ({downloadStatus.toUpperCase()})
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={downloadReport}
                    disabled={downloading || !summary}
                    startIcon={
                      downloading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        <Download />
                      )
                    }
                    sx={{ 
                      px: 6, 
                      py: 1.5, 
                      fontSize: "1.1rem",
                      background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
                      boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
                      "&:hover": {
                        background: "linear-gradient(45deg, #FF8E53 30%, #FE6B8B 90%)",
                        boxShadow: "0 5px 15px 2px rgba(255, 105, 135, .4)"
                      }
                    }}
                  >
                    {downloading ? "Downloading..." : `Download Report`}
                  </Button>
                </Box>
              </Paper>
            </>
          ) : (
            <Alert severity="info" sx={{ mt: 4 }}>
              Select a Financial Establishment to view summary
            </Alert>
          )}
        </Box>
      </Fade>

      <SnackBarComponent
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={closeSnackbar}
      />
    </Box>
  );
}
